import React, { useEffect, useCallback, useState} from 'react';
import MacroSlider from './MacroSlider.js';
import {connect} from 'react-redux';
import ParametersMapper from "components/effects/ParametersMapper.js";

const ZMacroComponent = ({macro, styling, zobject}) => { 
    let [show, setShow] = useState(false);
    if (!macro) {
        return '';
    }
    return (
        <div className="zmacro">
          <div>
            <MacroSlider styling={zobject.attributes} macro={macro}/>
            <div onClick={() => setShow(!show)} className={show ? "more-info-btn show" : "more-info-btn"}>
              <div className="dot"/>
              <div className="dot"/>
              <div className="dot"/>
            </div>
          </div>
          {show && <ParametersMapper isDraggable={false} effect={macro}/>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      styling: state.zobject.objectStylings[props.zobject.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZMacroComponent);
